// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import { getAnalytics } from 'firebase/analytics';
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFunctions } from 'firebase/functions';

export const environment = {
  production: false,
  firebaseConfig: {
    apiKey: 'AIzaSyC1qfeZD4nYna5Gm8iPILweaKNa6GpOqpI',
    authDomain: 'calculus-venture-app.firebaseapp.com',
    projectId: 'calculus-venture-app',
    storageBucket: 'calculus-venture-app.appspot.com',
    messagingSenderId: '866317173106',
    appId: '1:866317173106:web:c6562e0377d5e89c49ddeb',
    measurementId: 'G-SMVZPZJ0L3',
  },
  globalTimeout: 10000,
};

const app = initializeApp(environment.firebaseConfig);
const analytics = getAnalytics(app);
export const auth = getAuth(app);
export const functions = getFunctions(app);

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
